"use client";

import { LanguagesDisplay } from "./LanguagesDisplay";

export const LanguagesSection = () => {
  return (
    <div>
      <LanguagesDisplay />
    </div>
  );
};
